const MAX_INLINE_LABELS = 2;

/**
 * Trigger text for a multi-select filter that names itself. None selected
 * means "no narrowing", so it reads as `allLabel`, and so does all selected
 * unless `everyPickNarrows` (a code filter that still drops uncoded lines);
 * otherwise the selected labels, or `{prefix}: {count}` once they would not
 * fit. `namePicks` puts the prefix before the labels too, for codes that do
 * not say what they are, like a division code.
 */
export function filterSummary({
  selectedLabels,
  totalCount,
  allLabel,
  prefix,
  everyPickNarrows = false,
  namePicks = false,
}: {
  selectedLabels: string[];
  totalCount: number;
  allLabel: string;
  prefix: string;
  everyPickNarrows?: boolean;
  namePicks?: boolean;
}): string {
  const count = selectedLabels.length;
  if (count === 0) return allLabel;
  if (count >= totalCount && !everyPickNarrows) return allLabel;
  if (count > MAX_INLINE_LABELS) return `${prefix}: ${count}`;
  const labels = selectedLabels.join(', ');
  return namePicks ? `${prefix}: ${labels}` : labels;
}
